import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { createCareer } from "@/lib/api/careers.functions";
import { AdminFormFooter } from "@/components/admin/AdminFormFooter";
import { AdminPageHeader } from "@/components/admin/AdminPageHeader";
import { AdminPageShell } from "@/components/admin/AdminPageShell";
import { ContentAdminTabs } from "@/components/admin/ContentAdminTabs";
import { BlockDocEditor } from "@/components/admin/doc/BlockDocEditor";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { emptyEditorDoc, type EditorDoc } from "@/lib/doc/doc-types";

export const Route = createFileRoute("/admin/careers/new")({
  component: NewCareerPage,
});

function NewCareerPage() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("Penang");
  const [employmentType, setEmploymentType] = useState("Full-time");
  const [department, setDepartment] = useState("");
  const [editorDoc, setEditorDoc] = useState<EditorDoc>(emptyEditorDoc());
  const [saving, setSaving] = useState(false);

  async function handleSave() {
    setSaving(true);
    try {
      const row = await createCareer({
        data: {
          title,
          location,
          employmentType,
          department: department || undefined,
          editorDoc,
          status: "published",
        },
      });
      toast.success("Job created");
      navigate({ to: "/admin/careers/$id", params: { id: row.id } });
    } catch (e) {
      toast.error(e instanceof Error ? e.message : "Failed to create");
    } finally {
      setSaving(false);
    }
  }

  return (
    <AdminPageShell>
      <AdminPageHeader title="New job posting" />
      <ContentAdminTabs
        settingsLabel="Job settings"
        settingsForm={
          <div className="space-y-4">
            <div className="space-y-2"><Label>Title</Label><Input value={title} onChange={(e) => setTitle(e.target.value)} /></div>
            <div className="space-y-2"><Label>Location</Label><Input value={location} onChange={(e) => setLocation(e.target.value)} /></div>
            <div className="space-y-2"><Label>Employment type</Label><Input value={employmentType} onChange={(e) => setEmploymentType(e.target.value)} /></div>
            <div className="space-y-2"><Label>Department</Label><Input value={department} onChange={(e) => setDepartment(e.target.value)} placeholder="e.g. Tax, Audit, Advisory" /></div>
          </div>
        }
        content={
          <BlockDocEditor initialDoc={editorDoc} onChange={setEditorDoc} className="w-full" />
        }
      />
      <AdminFormFooter cancelTo="/admin/careers" onSave={handleSave} saving={saving} saveLabel="Create" savingLabel="Creating…" />
    </AdminPageShell>
  );
}
